import cx from 'classnames';

import { Typography } from '../../typography/Typography';

import style from './ReviewsCount.module.css';

interface ReviewsCountProps {
    reviewsCount?: string;
    size: 'xxs' | 'xs' | 'small' | 'medium' | 'large';
    inverse?: boolean;
}

function getTypographyScaleForReviewsCount(size: 'xxs' | 'xs' | 'small' | 'medium' | 'large') {
    if (size === 'xxs') {
        return 'primary-xxs-regular';
    }

    if (size === 'xs') {
        return 'primary-xs-regular';
    }

    return 'primary-body-regular';
}

export function ReviewsCount({ reviewsCount, size, inverse = false }: ReviewsCountProps) {
    if (!reviewsCount) return null;

    return (
        <div className={cx({ [style.inverse]: inverse })}>
            <Typography
                scale={getTypographyScaleForReviewsCount(size)}
                data-testid="ReviewRatingReviewsCount"
                className={style.reviewsCount}
            >
                {reviewsCount}
            </Typography>
        </div>
    );
}
